import { useEffect } from "react";
import { useQueries } from "react-query";
import { useDispatch } from "react-redux";
import { SWITCH_SLICES } from "../components/store/slices/switchSlices";
import { systemOf } from "../constants/systems";
import { getGraphTypeKey } from "../helpers/helpers";
import { getGraphService } from "../services";

export const useGetGraphQueries = (location, machine, swtName) => {
    const dispatch = useDispatch();
    const { key, graphTypes } = systemOf(swtName);

    const getSSRsQueries = useQueries(
        graphTypes.map((graphType) => ({
            queryKey: [machine, graphType],
            queryFn: () => getGraphService(machine, graphType),
            onSuccess: (data) => {
                if (data) {
                    const newData = {
                        location,
                        machine,
                        graphType: getGraphTypeKey(graphType),
                        data: data.graph,
                    };
                    dispatch(SWITCH_SLICES[key].setGraph(newData));
                }
            },
            onError: (error) => {
                console.error('get graph fail:', error.message);
            },
            staleTime: Infinity,
        }))
    );

    useEffect(() => {
        return () => {
            getSSRsQueries.forEach((query) => {
                query.remove();
            });
        };
    }, []);

    return getSSRsQueries;
}